import AUStates from './zh-TW/AU-states.json.js';
import CAStates from './zh-TW/CA-states.json.js';
import CNStates from './zh-TW/CN-states.json.js';
import CompanySize from './zh-TW/company-size.json.js';
import CompanyType from './zh-TW/company-type.json.js';
import countries from './zh-TW/countries.json.js';
import DEStates from './zh-TW/DE-states.json.js';
import HKStates from './zh-TW/HK-states.json.js';
import INStates from './zh-TW/IN-states.json.js';
import industry from './zh-TW/industry.json.js';
import interests from './zh-TW/interests.json.js';
import jobRole from './zh-TW/job-role.json.js';
import levelOfAWSUsage from './zh-TW/level-of-aws-usage.json.js';
import projectTimeline from './zh-TW/project-timeline.json.js';
import PTStates from './zh-TW/PT-states.json.js';
import USStates from './zh-TW/US-states.json.js';
import useCase from './zh-TW/use-case.json.js';
import languagePreference from './zh-TW/language-preference.json.js';
import Navatar from '../zh-TW/translation.json.js';

const dropdownsData = {
    ...AUStates,
    ...CAStates,
    ...CNStates,
    ...CompanySize,
    ...CompanyType,
    ...countries,
    ...DEStates,
    ...HKStates,
    ...INStates,
    ...industry,
    ...interests,
    ...jobRole,
    ...levelOfAWSUsage,
    ...projectTimeline,
    ...PTStates,
    ...USStates,
    ...useCase,
    ...Navatar.translation,
    ...languagePreference,
};

export { dropdownsData as default };
